// components/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getTranslation } from '../translations';
import '../styles/Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Détecter la langue actuelle depuis l'URL
  const getCurrentLang = () => {
    const path = location.pathname;
    if (path.startsWith('/en')) return 'en';
    if (path.startsWith('/amz')) return 'amz';
    return 'ar';
  };

  const [activeLang, setActiveLang] = useState(getCurrentLang());

  // Mettre à jour la langue et la direction quand l'URL change
  useEffect(() => {
    const lang = getCurrentLang();
    setActiveLang(lang);

    // Définir la direction du document
    // AR reste en LTR, EN et AMZ passent en RTL
    const direction = lang === 'ar' ? 'ltr' : 'rtl';
    document.documentElement.dir = direction;
    document.documentElement.lang = lang;
  }, [location.pathname]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Obtenir le chemin actuel sans le préfixe de langue
  const getPathWithoutLang = () => {
    const path = location.pathname;
    if (path.startsWith('/en/')) return path.substring(3);
    if (path.startsWith('/amz/')) return path.substring(4);
    return path === '/en' || path === '/amz' ? '/' : path;
  };

  // Créer le lien avec le préfixe de langue approprié
  const getLangLink = (path) => {
    if (activeLang === 'en') return path === '/' ? '/en' : `/en${path}`;
    if (activeLang === 'amz') return path === '/' ? '/amz' : `/amz${path}`;
    return path;
  };

  const handleLanguageClick = (lang) => {
    const currentPath = getPathWithoutLang();
    let newPath = currentPath;

    if (lang === 'en') {
      newPath = currentPath === '/' ? '/en' : `/en${currentPath}`;
    } else if (lang === 'amz') {
      newPath = currentPath === '/' ? '/amz' : `/amz${currentPath}`;
    } else if (lang === 'ar') {
      newPath = currentPath;
    }

    setActiveLang(lang);
    navigate(newPath);
  };

  // Vérifier si un lien est actif
  const isActive = (path) => {
    const currentPath = getPathWithoutLang();
    return currentPath === path;
  };

  const t = (key) => getTranslation(activeLang, key);

  return (
    <header className="header">
      <div className="containermenu">
        <div className="header-content">
          <Link to={getLangLink('/')} className="logo">
            {t('logo')}
          </Link>

          <button className="mobile-menu-button" onClick={toggleMenu}>
            {menuOpen ? '✕' : '☰'}
          </button>

          <nav>
            <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
              <li>
                <Link
                  to={getLangLink('/')}
                  onClick={closeMenu}
                  className={isActive('/') ? 'active-link' : ''}
                >
                  {t('home')}
                </Link>
              </li>
              <li>
                <Link
                  to={getLangLink('/about')}
                  onClick={closeMenu}
                  className={isActive('/about') ? 'active-link' : ''}
                >
                  {t('about')}
                </Link>
              </li>

              <li>
                <Link
                  to={getLangLink('/caravan')}
                  onClick={closeMenu}
                  className={isActive('/caravan') ? 'active-link' : ''}
                >
                  {t('caravan')}
                </Link>
              </li>
              <li>
                <Link
                  to={getLangLink('/stands')}
                  onClick={closeMenu}
                  className={isActive('/stands') ? 'active-link' : ''}
                >
                  {t('stands')}
                </Link>
              </li>
              <li>
                <Link
                  to={getLangLink('/chiffres')}
                  onClick={closeMenu}
                  className={isActive('/chiffres') ? 'active-link' : ''}
                >
                  {t('numbers')}
                </Link>
              </li>
              <li>
                <Link
                  to={getLangLink('/spectacle')}
                  onClick={closeMenu}
                  className={isActive('/spectacle') ? 'active-link' : ''}
                >
                  {t('spectacle')}
                </Link>
              </li>
              <li className="language-selector-item">
                <div className="language-selector">
                <button
                  className={`lang-btn ${activeLang === 'en' ? 'active' : ''}`}

                  onClick={() => handleLanguageClick('en')}
                >
                  EN
                </button>
                  <span className="lang-separator">|</span>
                  <button
                    className={`lang-btn ${activeLang === 'ar' ? 'active' : ''}`}
                    onClick={() => handleLanguageClick('ar')}
                  >
                    ع
                  </button>

                  <span className="lang-separator">|</span>
                  <button
                    className={`lang-btn ${activeLang === 'amz' ? 'active' : ''}`}
                    onClick={() => handleLanguageClick('amz')}
                  >
                    ⵎⵣⵖ
                  </button>
                </div>
              </li>

            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
